import { render, staticRenderFns } from "./c-zoom-overlay.vue?vue&type=template&id=44d23d02&"
import script from "./c-zoom-overlay.vue?vue&type=script&lang=js&"
export * from "./c-zoom-overlay.vue?vue&type=script&lang=js&"
import style0 from "./c-zoom-overlay.vue?vue&type=style&index=0&id=44d23d02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports